import { IconPencil } from '@tabler/icons-react';
import { memo, useCallback } from 'react';
import PlayerMenuTooltip from '../PlayerMenus/PlayerMenuTooltip';
import EventBus from '@/libs/eventBus/eventBus';
import { CustomEvents } from '@/libs/eventBus/constants';

function SpeakerLabelEditButton({ speakerId }: { speakerId: string }) {
  const editSpeakerLabel = useCallback(() => {
    EventBus.dispatch(CustomEvents.OpenContentSettings, { speakerId });
  }, [speakerId]);

  return (
    <button
      onClick={editSpeakerLabel}
      data-testid="speaker-label-edit-button"
      className="group/button flex size-10 items-center justify-center rounded-md hover:bg-slate-100"
    >
      <IconPencil size={20} />
      <PlayerMenuTooltip content="Edit speaker" />
    </button>
  );
}

export default memo(SpeakerLabelEditButton);
